<template>
	<div class="report-form">
		<div class="report-form-row-2">
			<ja-dropdown
				v-model="simulationType"
				required
				:placeholder="$t('simTypePlaceholder')"
				:label="$t('simulationTypeLbl')"
				:options="simulationTypes"
				name="simulationType"
			></ja-dropdown>
		</div>
	</div>
</template>
<script>
import ReportingMixin from '@/mixins/ReportingMixin';
import AdminFacility from '@/mixins/AdminFacility';
import Dropdown from '@/components/ui/form/Dropdown';

export default {
	components: {
		jaDropdown: Dropdown
	},
	mixins: [ReportingMixin, AdminFacility],
	props: {
		filters: {
			type: Object,
			default: null
		},
		simulationTypes: {
			type: Array,
			default: () => {
				return [];
			}
		},
		clear: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		activeFilters() {
			if (this.filters) {
				return this.filters;
			}

			return {
				facility: this.selectedFacilityId,
				simulationType: null
			};
		},
		requiredFieldsPopulated() {
			return this.selectedFacilityId >= 0 && this.simulationType >= 0;
		}
	},
	watch: {
		clear(value) {
			if (value === true) {
				this.facilityChanged();
			}
		},
		selectedFacility(newValue) {
			this.activeFilters.facility = newValue.facility_ID;

			this.$emit('filtersUpdated', this.activeFilters);
		},
		simulationType(newValue) {
			if (newValue >= 0) {
				this.activeFilters.simulationType = this.simulationTypes[
					newValue
				].value;
			} else {
				this.activeFilters.simulationType = null;
			}
			this.$emit('filtersUpdated', this.activeFilters);
		}
	},
	methods: {
		facilityChanged() {
			this.simulationType = -1;
		}
	}
};
</script>
